
// src/components/.../renderCheckbox.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

const getDocMessages = (PONo) => ({
  MissingDoc1: {
    true: `PO Number: ${PONo} - Shipper needs ORIGINAL HBL.`,
    false: `PO Number: ${PONo} - HBL requirement met. Freight will now be released.`,
  },
  MissingDoc2: {
    true: `PO Number: ${PONo} - Missing Commercial Invoice and/or Packing List.`,
    false: `PO Number: ${PONo} - Commercial Invoice and/or Packing List received.`,
  },
  MissingDoc3: {
    true: `PO Number: ${PONo} - Origin charges not received.`,
    false: `PO Number: ${PONo} - Origin charges received.`,
  },
});

class RenderCheckbox extends Component {
  onChange = (e) => {
    const { input, docName, detailID, BookingID, PONo, docAlert } = this.props;
    const checked = e.target.checked;

    // Update Redux Form field (boolean)
    input.onChange(checked);

    // Prepare payload for backend (1/0)
    const values = { [docName]: checked ? 1 : 0 };

    // Build message with current PONo
    const DOC_MESSAGES = getDocMessages(PONo);
    const msg = { Comments: (DOC_MESSAGES[docName] ?? {})[checked] ?? '' };

    docAlert(`${detailID}`, BookingID, values, msg, () => {
      window.location.reload(true);
    });
  };

  render() {
    const { label, input, meta: { touched, error } = {}, docName, detailID } = this.props;
    const isChecked = !!input.value;
    const inputId = `checkbox-${docName}-${detailID}`;

    return (
      <div className="form-group form-group-sm col-sm-4">
        <div className="row align-items-center">
          <div className="col-sm-1">
            <input
              id={inputId}
              type="checkbox"
              className="form-check-input"
              style={{ border: '2px solid #333' }}
              checked={isChecked}
              onChange={this.onChange}
              aria-invalid={touched && !!error}
              aria-describedby={touched && error ? `${inputId}-error` : undefined}
            />
          </div>
          <label htmlFor={inputId} className="col-sm-9 col-form-label">
            {label}
          </label>
          <div className="text-danger" id={`${inputId}-error`}>
            {touched ? error : ''}
          </div>
        </div>
      </div>
    );
  }
}

// Map the needed action as a prop so we can call this.props.docAlert(...)
const mapDispatchToProps = {
  docAlert: actions.docAlert,
};

// No state needed here, so first arg is null
export default connect(null, mapDispatchToProps)(RenderCheckbox);
